import { render, staticRenderFns } from "./MoleculeEditionBillingMyPaymentsBillingData.vue?vue&type=template&id=5f070b6f&"
import script from "./MoleculeEditionBillingMyPaymentsBillingData.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionBillingMyPaymentsBillingData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports